import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class CreateRefundCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(service_delivery_id, charge_id, charge_amount, refund_percentage, product_code): Promise<{ [key: string]: string; }> {
    let args = {
      service_delivery_id:service_delivery_id,
      charge_id:charge_id,
      charge_amount:charge_amount,
      refund_percentage:refund_percentage
    };
    let cmd_name = 'create.refund';
    if (product_code) {
      args['product_code'] = product_code;
      cmd_name = 'create.charge.refund';
    }
    try {
      return this.dispatcher.dispatch(cmd_name, args);
    } catch(error) {
      console.error('Error al realizar abono', error)
    }
  }
}